import 'models/logistic'
import { LogisticFilial, LogisticFilialStatus } from 'models/logistic-filial'
import { PaginationParams, PaginationResponse } from 'models/pagination'

export enum LogisticFilialReportType {
  DEFAULT = 'excel',
  BY_USERS = 'excel_by_users',
}

export interface GetLogisticFilialsResponse
  extends PaginationResponse<{
    client_full_name: LogisticFilial['client_full_name']
    created_at: LogisticFilial['created_at']
    get_cart_type_display: string
    get_degree_urgency_display: string
    get_status_display: string
    id: LogisticFilial['id']
    pan: LogisticFilial['pan']
  }> {}

export interface GetLogisticFilialsParams extends PaginationParams {
  start_date?: string
  end_date?: string
  status?: LogisticFilialStatus
  pan?: string
  search?: string
  branch?: string
  degree_urgency?: string
}

export interface CreateLogisticFilial {
  date_embossment: LogisticFilial['date_embossment']
  client_full_name: LogisticFilial['client_full_name']
  phone: LogisticFilial['phone']
  pan: LogisticFilial['pan']
  cart_type: LogisticFilial['cart_type']
  branch: number
  degree_urgency?: LogisticFilial['degree_urgency']
  status?: LogisticFilial['status']
  comment?: LogisticFilial['comment']
  specialist?: LogisticFilial['specialist']
}

export interface UpdateLogisticFilialStatus {
  id: LogisticFilial['id']
  body: {
    status: LogisticFilialStatus
    comment?: string
  }
}
